module.exports = __webpack_public_path__ + "static/media/JM_iconos-05_linea.20b8249f.svg";